import React, { useEffect } from "react";


const PaySlipSettings = () => {
    return <div>PaySlipSettings</div>
}

export default PaySlipSettings;